import { META } from 'app/constants';

const INIT_STATE = { versionInfo: null };

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case META.SET_VERSION:
      return { ...state, versionInfo: action.payload };
    default:
      return state;
  }
};
